import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import camelCase from 'lodash/camelCase';
import { BrandListItem, BrandListItemContent }
from '@fuww/library/src/List/BrandList';
import { List, ListContainer } from '@fuww/library/src/List/index';
import { useSiteContext } from '../../SiteContext';
import ImageWithUrls from '../../ImageWithUrls';
import loadMore from '../../../lib/queries/loadMore';
import LoadMore from '../../LoadMore';
import LinkAndAnchor from '../../LinkAndAnchor';

const EpbList = ({
  searchVariables,
  fetchMore,
  field,
  data,
  listItems,
  loading,
  route,
  useRouter,
  showLoader,
}) => {
  const { locale } = useSiteContext();
  const { edges, pageInfo } = { ...listItems };
  const hasNextPage = pageInfo?.hasNextPage ?? false;

  const rows = showLoader
    ? Array.from({ length: 3 }, (_, index) => (
      <Fragment key={`skeleton-${index}`}>
        <BrandListItem>
          <BrandListItemContent
            showLoader={showLoader}
          />
        </BrandListItem>
      </Fragment>
    ))
    : edges?.map(({ node: profile }, index) => {
      const {
        id,
        company: {
          fullName, logoUrls, description, descriptions,
        },
        page: { slug, premium },
      } = profile;

      const { [camelCase(locale)]: localizedDescription } = { ...descriptions };
      const sourceSet = `${logoUrls[1]
      } 60w, ${logoUrls[2]
      } 120w`;

      const isFirstImage = index === 0;
      const fetchPriority = isFirstImage ? 'high' : 'low';

      return (
        <BrandListItem key={id}>
          <LinkAndAnchor
            route={route}
            params={{ companySlug: slug }}
            useRouter={useRouter}
          >
            <BrandListItemContent
              description={(
                <span
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: localizedDescription || description,
                  }}
                />
              )}
              title={fullName}
              logo={
                logoUrls[0] && (
                  <ImageWithUrls
                    imageUrls={logoUrls}
                    title={fullName}
                    alt={fullName}
                    width="60px"
                    height="auto"
                    objectFit="cover"
                    preload={isFirstImage}
                    placeholderFetchpriority={fetchPriority}
                    finalFetchpriority={fetchPriority}
                    sizes="60px"
                    srcSet={sourceSet}
                  />
                )
              }
              premium={premium}
            />
          </LinkAndAnchor>
        </BrandListItem>
      );
    });

  return (
    <ListContainer>
      <List className="fu-mdc-list">
        {rows}
      </List>
      <LoadMore
        hasNextPage={hasNextPage}
        loading={loading}
        fetchMore={
          () => loadMore({ searchVariables })(data, field, fetchMore)
        }
      />
    </ListContainer>
  );
};

EpbList.propTypes = {
  searchVariables: PropTypes.shape({}).isRequired,
  fetchMore: PropTypes.func.isRequired,
  field: PropTypes.string,
  listItems: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape({})),
    pageInfo: PropTypes.shape({
      hasNextPage: PropTypes.bool,
      hasPreviousPage: PropTypes.bool,
    }),
  }),
  data: PropTypes.shape({}),
  loading: PropTypes.bool.isRequired,
  route: PropTypes.string.isRequired,
  useRouter: PropTypes.bool,
  showLoader: PropTypes.bool,
};

EpbList.defaultProps = {
  data: {},
  field: 'profilesConnection',
  useRouter: false,
  showLoader: false,
  listItems: {},
};

export default EpbList;
